import React, { useEffect } from 'react';

import { LinkCardCustom } from '../../../components/Cards/LinkCard';
import Accordion from '../../../components/Accordion';
import { useBeneficiarioEventual } from '../../../contexts/BeneficiarioEventual/context';

import { PageContainer } from '../../../styles/styles';
import * as S from './styles';

function BeneficiarioEventual() {
    const LINK_TO_AGENDAMENTO = '/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta';
    const LINK_TO_CANCELAMENTO = '/dados_beneficiario/consulta_beneficiario_eventual/cancelamento_consulta';
    const LINK_TO_HISTORICO = '/dados_beneficiario/historico_consultas';

    const { clearBeneficiarioEventual } = useBeneficiarioEventual();

    useEffect(() => {
        clearBeneficiarioEventual();
    }, []);

    return (
        <PageContainer>
            <Accordion title="Escolha a modalidade que você quer adicionar" hasCollapse={false}>
                <S.ContainerCards>
                    <LinkCardCustom
                        link={LINK_TO_AGENDAMENTO}
                        title="Agendamento de consulta"
                        desc="Pessoa contratada pela empresa, efetue agendamento da consulta aqui."
                        icons={{ left: { name: 'date_range' } }}
                    />

                    <LinkCardCustom
                        link={LINK_TO_CANCELAMENTO}
                        title="Cancelamento de consulta"
                        desc="Pessoa contratada pela empresa, efetue o cancelamento da consulta aqui."
                        icons={{ left: { name: 'delete_outline' } }}
                    />

                    <LinkCardCustom
                        link={LINK_TO_HISTORICO}
                        title="Histórico de consulta"
                        desc="Pessoa contratada pela empresa. Visualize histórico de consulta aqui."
                        icons={{ left: { name: 'article' } }}
                    />
                </S.ContainerCards>
            </Accordion>
        </PageContainer>
    );
}

export default BeneficiarioEventual;
